/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Beginner_2_HeadingInputs */

const en_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What your first swings feel like`)
};

const es_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se sienten tus primeros swings`)
};

const de_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie sich Ihre ersten Schwünge anfühlen`)
};

const zh_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初的挥杆是什么感觉`)
};

const ar_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف تشعر ضرباتك الأولى`)
};

const fr_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quoi ressemblent vos premiers swings`)
};

const vi_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm giác những cú swing đầu tiên`)
};

const sw_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinsi swing zako za kwanza zinavyohisi`)
};

const th_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวิงแรกๆ ของคุณจะรู้สึกอย่างไร`)
};

const bs_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kako se osjećaju tvoji prvi swingovi`)
};

const ja_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のスイングはどんな感覚か`)
};

const ko_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 스윙은 어떤 느낌일까`)
};

const pt_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são seus primeiros swings`)
};

const it_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si sentono i primi swing`)
};

const sv_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur dina första svingar känns`)
};

const nl_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe je eerste swings voelen`)
};

const da_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan føles dine første sving`)
};

const nb_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slik kjennes de første svingene`)
};

const fi_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miltä ensimmäiset svingisi tuntuvat`)
};

const pl_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakie są Twoje pierwsze swingi`)
};

const ru_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какими будут ваши первые свинги`)
};

const tr_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk swinglerinizin hissi`)
};

const hi_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके पहले स्विंग कैसे लगते हैं`)
};

const id_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seperti apa rasanya ayunan pertama Anda`)
};

const ms_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana rasanya hayunan pertama anda`)
};

const cs_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaké jsou vaše první švihy`)
};

const el_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πώς νιώθετε στα πρώτα σας σβινγκ`)
};

const he_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`איך מרגישים הסווינגים הראשונים שלכם`)
};

const af_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe jou eerste swaaie voel`)
};

const hu_method_content_step_02_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milyen érzés lesz az első néhány swing`)
};

/**
* | output |
* | --- |
* | "What your first swings feel like" |
*
* @param {Method_Content_Step_02_Detail_Beginner_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_beginner_2_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Beginner_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Beginner_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_beginner_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_beginner_2_heading(inputs)
	return en_method_content_step_02_detail_beginner_2_heading(inputs)
});